import { useField } from 'formik'
import * as Styled from './styled'
import { Props } from './types'

function Radio({ onChange, ...props }: Props) {
  const [field] = useField<string>(props)

  function handleChange(event: CustomEvent<EventSource>) {
    const target = event.target as HTMLInputElement

    field.onChange({ target: { name: props.name, value: target.value } })
    onChange?.()
  }


  return (
    <Styled.Radio data-testid={`radio-${props.name}`} {...props} radioId={props.name} checked={field.value === props.value} onFuel-change={handleChange} />
  )
}

export default Radio
